import { Button, Grid, Tooltip, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../css/global.css"; // Importa el archivo global.css
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { Add } from "@mui/icons-material";
import getColumnsMemoriasPF from "../../../layout/Columns/ColumnsMemoriasPF";
import axios from "axios";
import { puedeCrear } from "../../../utils/permisosFlujo";

export interface fechaOrNull {
    fecha: string;
}

export default function CalculosPF() {
    const BASEURL = `${process.env.REACT_APP_APPLICATION_ENDPOINT}/participaciones/federales/memorias/`;
    const TITULO = "Participaciones Federales Memorias de Cálculos";
    const navigate = useNavigate();
    const [dataLoading, setDataLoading] = useState(false);
    const [uuidrow, setUuidRow] = React.useState();
    const [rows, setRows] = useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(25);
    const [totalRows, setTotalRows] = React.useState(0);
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;
    const rowsPaginated = rows.slice(startIndex, endIndex);


    const openSolicitud = () => {
        const url = `/admin/participaciones/federales/solicitudcalculospf`;
        navigate(url);
    };

    const handleVerClick = (id: string, link: string) => {
        navigate("/" + link + "/alta/" + id);
    };

    const columns = getColumnsMemoriasPF({ handleVerClick, urlOrigen: '/usuarios/listado', navigate });


    const getData = async () => {
        setDataLoading(true);
        try {
            const token = localStorage.getItem('jwtToken');

            const response = await axios.get(BASEURL + 'lista', {
                headers: {
                    'Authorization': `${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setRows(response.data.data);  // Suponiendo que la respuesta tiene el campo data con las memorias
            setTotalRows(response.data.data.length);
        } catch (err) {
            console.error('Error al obtener las memorias:', err);
        } finally {
            setDataLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [rows]);

    return (
        <Grid container sx={{}}>
            <Grid sx={{}} item xs={12}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        // { texto: "Configuración", link: "" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid container >
                <Grid item width={"100%"}>
                    <Typography
                        variant="h5"
                        component="div"
                        sx={{
                            flexGrow: 1,
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "left",
                        }}
                    >
                        {TITULO}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} md={1} lg={2} mt={1}>
                    {
                        puedeCrear() &&
                        <Tooltip title="Alta Memoria de Cálculo">
                            <Button
                                onClick={() => openSolicitud()}
                                sx={{ marginLeft: "5px", textTransform: "capitalize" }}
                                variant="contained"
                                size="small"
                            >
                                <Add /> Agregar
                            </Button>
                        </Tooltip>
                    }
                </Grid>

                <Grid
                    sx={{
                        justifyContent: "center",
                        paddingTop: "1px",
                        height: "8px",
                        display: "",
                    }}
                    item
                    xs={12}
                    md={12}
                    mt={2}
                ></Grid>
            </Grid>

            <TablePaginate
                rowsInfo={rowsPaginated}
                columns={columns}
                Mostrar={false}
                loading={dataLoading}
            />
        </Grid >
    );
}
